import debounce from "@/utils/debounce"
import api from "@/api"
import { go } from "@/utils/location"

const MIN_SEATS = 5
const MAX_SEATS = 50
const STEP_SEATS = 1

const state = {
  minSeats: MIN_SEATS,
  maxSeats: MAX_SEATS,
  stepSeats: STEP_SEATS,
  seats: MIN_SEATS,
  loading: false,
  error: null,
  isActiveSubscriber: null,
  plan: {
    loading: false,
    error: null,
    value: null
  }
}

const mutations = {
  seats: (state, payload) => {
    state.seats = payload
  },

  loading: (state, payload) => {
    state.loading = payload
  },

  error: (state, payload) => {
    state.error = payload
  },

  isActiveSubscriber: (state, payload) => {
    state.isActiveSubscriber = payload
  },

  plan: (state, payload) => {
    state.plan = {
      ...state.plan,
      ...payload
    }
  }
}

const getters = {
  priceMarkup: (state) => {
    if (!state.plan.value) {
      return "-"
    }
    return state.plan.value.price.final.markup
  },

  teamOwnerPrice: (state) => {
    if (!state.plan.value) {
      return "-"
    }
    if (state.plan.value.currency === "eur") {
      return "0,00€"
    } else {
      return "$0.00"
    }
  },

  extraMaxSeats: (state) => {
    return state.maxSeats + 1
  },

  isPlanLoading: (state) => {
    return state.plan.loading
  }
}

const actions = {
  seats: ({ commit, dispatch }, payload) => {
    commit("seats", payload)
    return dispatch("callApi")
  },

  callApi: debounce(({ state, commit }) => {
    commit("plan", { loading: true })
    return api
      .plans({
        currency: "usd",
        seats: state.seats,
        productType: "teams"
      })
      .then((data) => {
        commit("plan", { value: data.plan })
        commit("isActiveSubscriber", data.isActiveSubscriber)
        commit("plan", { loading: false })
      })
      .catch((err) => {
        commit("plan", {
          error: err
        })
        commit("plan", { loading: false })
      })
  }, 500),

  submit: ({ state, commit }) => {
    commit("loading", true)
    commit("error", false)
    return api.teams
      .create({
        seats: state.seats
      })
      .then((response) => {
        commit("loading", false)
        go(response.data.redirect)
      })
      .catch(() => {
        commit("error", true)
        commit("loading", false)
      })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
